export const LinearData = [
  {
    "Year": 1,
    "Reward": 50
  },
  {
    "Year": 2,
    "Reward": 50
  },
  {
    "Year": 3,
    "Reward": 50
  },
  {
    "Year": 4,
    "Reward": 50
  },
  {
    "Year": 5,
    "Reward": 50
  },
  {
    "Year": 6,
    "Reward": 50
  },
  {
    "Year": 7,
    "Reward": 50
  },
  {
    "Year": 8,
    "Reward": 50
  },
  {
    "Year": 9,
    "Reward": 50
  },
  {
    "Year": 10,
    "Reward": 50
  },
  {
    "Year": 11,
    "Reward": 50
  },
  {
    "Year": 12,
    "Reward": 50
  },
  {
    "Year": 13,
    "Reward": 50
  },
  {
    "Year": 14,
    "Reward": 50
  },
  {
    "Year": 15,
    "Reward": 50
  },
  {
    "Year": 16,
    "Reward": 50
  },
  {
    "Year": 17,
    "Reward": 50
  },
  {
    "Year": 18,
    "Reward": 50
  },
  {
    "Year": 19,
    "Reward": 50
  },
  {
    "Year": 20,
    "Reward": 50
  }
 ]
